import { AppState } from 'Store'

const selectInfo = (state: AppState) => state.iBro.bgLimits.clientLimitInfo.info
const selectLoading = (state: AppState) => state.iBro.bgLimits.clientLimitInfo.loading
const selectDisableNext = (state: AppState) => state.iBro.bgLimits.clientLimitInfo.disableNext
const selectSupportInfo = (state: AppState) => state.iBro.bgLimits.clientLimitInfo.supportInfo
const selectDadataInfo = (state: AppState) => state.iBro.bgLimits.clientLimitInfo.dadataInfo

export const clientLimitInfoSelector = {
	selectInfo,
	selectLoading,
	selectDisableNext,
	selectSupportInfo,
	selectDadataInfo,
}
